import {
  FuelSurchargeSchedule_Read,
  FuelSurchargeSchedule_Read_Nested,
  FuelSurchargeSchedule_Read_Typeahead,
  FuelSurchargeSchedulePrice_Read,
  FuelSurchargeScheduleType,
} from '@treadinc/horizon-api-spec';
import dayjs, { Dayjs } from 'dayjs';

import { FuelPriceIndexBasic } from '~hooks/useFuelPriceIndices/models';

export class FuelSurchargeSchedule {
  constructor(
    private _id: string,
    private _name: string,
    private _fuel_price_index: FuelPriceIndexBasic,
    private _surcharge_type: FuelSurchargeScheduleType,
    private _created_at: Dayjs,
    private _updated_at: Dayjs,
    private _discarded_at: Dayjs | null = null,
  ) {}

  public get id() {
    return this._id;
  }

  public get name() {
    return this._name;
  }

  public get fuelPriceIndex() {
    return this._fuel_price_index;
  }

  public get surchargeType() {
    return this._surcharge_type;
  }

  public get createdAt() {
    return this._created_at;
  }

  public get updatedAt() {
    return this._updated_at;
  }

  public get discardedAt() {
    return this._discarded_at;
  }

  public static parse(proto: FuelSurchargeSchedule_Read) {
    return new FuelSurchargeSchedule(
      proto.id,
      proto.name,
      FuelPriceIndexBasic.parse(proto.fuel_price_index),
      proto.surcharge_type,
      dayjs(proto.created_at),
      dayjs(proto.updated_at),
      proto.discarded_at ? dayjs(proto.discarded_at) : null,
    );
  }
}

export class FuelSurchargeSchedulePrice {
  constructor(
    private _id: string,
    private _price: number,
    private _billing_surcharge: number,
    private _created_at: Dayjs,
    private _updated_at: Dayjs,
    private _discarded_at: Dayjs | null = null,
  ) {}

  public get id() {
    return this._id;
  }

  public get price() {
    return this._price;
  }

  public get billingSurcharge() {
    return this._billing_surcharge;
  }

  public get createdAt() {
    return this._created_at;
  }

  public get updatedAt() {
    return this._updated_at;
  }

  public get discardedAt() {
    return this._discarded_at;
  }

  public static parse(
    proto: FuelSurchargeSchedulePrice_Read,
  ): FuelSurchargeSchedulePrice {
    return new FuelSurchargeSchedulePrice(
      proto.id,
      Number(proto.price),
      Number(proto.bill_surcharge),
      dayjs(proto.created_at),
      dayjs(proto.updated_at),
      proto.discarded_at ? dayjs(proto.discarded_at) : null,
    );
  }
}
export class FuelSurchargeScheduleTypeahead {
  constructor(
    private _id: string,
    private _name: string,
  ) {}

  public get id(): string {
    return this._id;
  }

  public get name(): string {
    return this._name;
  }

  public static parse(proto: FuelSurchargeSchedule_Read_Typeahead) {
    return new FuelSurchargeScheduleTypeahead(proto.id, proto.name);
  }
}

export class FuelSurchargeScheduleBasic {
  constructor(
    private _id: string,
    private _name: string,
    private _discarded_at: Dayjs | null = null,
  ) {}

  public get id(): string {
    return this._id;
  }

  public get name(): string {
    return this._name;
  }

  public get discardedAt() {
    return this._discarded_at;
  }

  public static parse(proto: FuelSurchargeSchedule_Read_Nested) {
    return new FuelSurchargeScheduleBasic(
      proto.id,
      proto.name,
      proto.discarded_at ? dayjs(proto.discarded_at) : null,
    );
  }
}
